'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.prompt', ['ngMaterial']).factory('fPrompt', function ($mdDialog) {
  return function (config, event) {
    return $mdDialog.show({
      event: event,
      controller: function controller($scope, $mdDialog) {
        $scope.cancel = function () {
          $mdDialog.cancel();
        };

        $scope.answer = function (answer) {
          $mdDialog.hide(answer);
        };

        $scope.conf = config || {};
        $scope.class = config.class || '';
        $scope.conf.action = config.action || 'Ok';
        $scope.conf.cancel = config.cancel || 'Cancel';
        $scope.conf.type = config.type || 'text';
      },
      template: require('./tpl.html')
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./prompt/index.js
// module id = 142
// module chunks = 0